// extracted by mini-css-extract-plugin
module.exports = {"row":"style_row__1ZR0h","label":"style_label__h3g1D"};